import localforage from 'localforage';

localforage.config({
    driver: [localforage.INDEXEDDB,
    localforage.LOCALSTORAGE
    ],
    name: 'db-root'
});

export const tools = {
    //json to css
    json2css: function (json) {
        let css = '';
        for (let key in json) {
            css += `${key}:${json[key]};`
        }
        return css;
    },

    // 获取样式
    getStyle: function (dom) {
        // 获取样式
        let style = {};
        if (dom) {
            let styleStr = dom.getAttribute('style');
            if (styleStr) {
                styleStr.split(';').forEach(item => {
                    let [key, value] = item.split(':');
                    style[key] = value;
                })
            }
        }
        return style;
    },
    //函数节流
    throttle: function (fn, delay) {
        let timer = null;
        return function () {
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(() => {
                fn.apply(this, arguments);
            }, delay);
        }
    }
}

// 随机颜色
export const randomColor = () => {
    return '#' + Math.floor(Math.random() * 0xffffff).toString(16).padEnd(6, '0');
}

// uuid
export const uuid = () => {
    let s = [];
    let hexDigits = "0123456789abcdef";
    for (let i = 0; i < 36; i++) {
        let start = Math.floor(Math.random() * 0x10);
        s[i] = hexDigits.substring(start, start + 1);
    }
    s[14] = "4";
    let start2 = (s[19] & 0x3) | 0x8;
    s[19] = hexDigits.substring(start2, start2 + 1);
    s[8] = s[13] = s[18] = s[23] = "-";

    let uuid = s.join("");
    return uuid;
}
// 简单10位随机id
export const rid = () => {
    return Math.random().toString(36).substring(2);;
}

// 

// 字符串加密
export const encrypt = {
    // 加密
    /**
     * 
     * @param {string} str 要加密的字符串
     * @param {string} key 密钥
     * @returns {string} 
     */
    encrypt: function (str, key) {
        let cipher = '';
        for (let i = 0; i < str.length; i++) {
            let char = str.charCodeAt(i);
            let keyChar = key.charCodeAt(i % key.length);
            cipher += String.fromCharCode(char + keyChar);
        }
        return encodeURI(cipher);
    },
    // 解密
    /**
     * 
    * @param {string} str 要解密的字符串
     * @param {string} key 密钥
     * @returns {string}
     */
    decrypt: function (str, key) {
        str = decodeURI(str)
        let decipher = '';
        for (let i = 0; i < str.length; i++) {
            let char = str.charCodeAt(i);
            let keyChar = key.charCodeAt(i % key.length);
            decipher += String.fromCharCode(char - keyChar);
        }
        return decipher;
    }
}

/**
 * 本地保存
 */
export const storage = {
    set(key, value) {
        if (typeof value === 'object') {
            JSON.stringify(value)
        }
        window.localStorage.setItem(key, JSON.stringify(value));
    },
    get(key) {
        let val = window.localStorage.getItem(key)
        try {
            return JSON.parse(val);
        } catch (error) {
            return val
        }
    },



    remove(key) {
        window.localStorage.removeItem(key);
    },
    setItem(key, value) {
        if (!key) return;
        try {
            return localforage.setItem(key, value)
        } catch (error) {
            return Promise.reject(error);
        }
    },
    getItem(key) {
        if (!key) return;
        try {
            return localforage.getItem(key)
        } catch (error) {
            return Promise.reject(error);
        }
    },
    removeItem(key) {
        if (!key) return;
        try {
            return localforage.removeItem(key)
        } catch (error) {
            return Promise.reject(error);
        }
    }
};



//得到上一个月有多少天
function getlastmonthDay(date) {
    date.setDate(1);
    date.setDate(date.getDate() - 1);
    return date.getDate();
}
//获取指定日期的后一天日期
function getNextDay(d) {
    d = new Date(d);
    d = +d + 1000 * 60 * 60 * 24;
    d = new Date(d);
    let res = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
    return new Date(res);
}
//获取 date 所在的月有多少天
function getlastDay(date) {
    date.setMonth(date.getMonth() + 1);
    date.setDate(1);
    date.setDate(date.getDate() - 1);
    return date.getDate();
}

// 获取两个日期之间的月份和天数
export const getMonthAndDay = (startdate, enddate) => {

    startdate = typeof startdate == 'string' ? new Date(startdate) : startdate;
    enddate = typeof enddate == 'string' ? new Date(enddate) : enddate

    if (startdate.valueOf() > enddate.valueOf()) {
        let tmpdt = enddate;
        enddate = startdate;
        startdate = tmpdt;
    }
    let month = 0;
    let day = 0;
    enddate = getNextDay(enddate);
    if (enddate.getTime() >= startdate.getTime()) {
        month = (enddate.getFullYear() - startdate.getFullYear()) * 12 + enddate.getMonth() - startdate.getMonth();
        day = enddate.getDate() - startdate.getDate();
        if (day < 0) {
            let lastmonthdaynum = getlastmonthDay(enddate);
            day += lastmonthdaynum;
            if (lastmonthdaynum < 30 && startdate.getDate() > 28) {
                day += startdate.getDate() - lastmonthdaynum - 1;
            }
            month--;
        }
    } else {
        if (startdate.getTime() == getlastDay(startdate)) {
            if (enddate.getTime() == getlastDay(enddate)) {
                month = enddate.getFullYear() - startdate.getFullYear() * 12 + enddate.getMonth() - startdate.getMonth();
                day = 0;
            } else {
                month = enddate.getFullYear() - startdate.getFullYear() * 12 + enddate.getMonth() - startdate.getMonth() - 1;
                day = startdate.getDate();
            }
        } else {
            if (enddate.getTime() == getlastDay(enddate)) {
                month = enddate.getFullYear() - startdate.getFullYear() * 12 + enddate.getMonth() - startdate.getMonth();
                day = 0;
            } else {
                month = enddate.getFullYear() - startdate.getFullYear() * 12 + enddate.getMonth() - startdate.getMonth() - 1;
                let lastmonthday = getlastmonthDay(enddate);
                day = lastmonthday - startdate.getDate() + enddate.getDate();
            }
        }
    }
    return { "month": month, "day": day };
}

// 深拷贝数组
export const deepClone = (obj) => {
    let result = Array.isArray(obj) ? [] : {};
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (typeof obj[key] === 'object') {
                result[key] = deepClone(obj[key]);
            } else {
                result[key] = obj[key];
            }
        }
    }
    return result;
};
